// Handles drag-and-drop and filename preview for project thumbnail uploads.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropzone", "input"]

  dragOver(event) {
    event.preventDefault()
    this.setDragState(true)
  }

  dragLeave(event) {
    event.preventDefault()
    this.setDragState(false)
  }

  drop(event) {
    event.preventDefault()
    this.setDragState(false)

    const files = event.dataTransfer.files
    if (!files || files.length === 0) {
      return
    }

    // Build a synthetic FileList so the native file input receives dropped files.
    const dataTransfer = new DataTransfer()
    Array.from(files).forEach((file) => dataTransfer.items.add(file))
    this.inputTarget.files = dataTransfer.files
  }

  setDragState(active) {
    this.dropzoneTarget.classList.toggle("border-primary", active)
    this.dropzoneTarget.classList.toggle("bg-light", active)
  }
}
